import React from 'react';
import { Badge } from '@/components';
import { Utils } from '@/shared/Utils';
import { CloseIcon } from '@/components/Icons';

type StopwordCardProps = {
    matchedWord: string;
    title: string;
    message: string;
    badgeText?: string | null;
    onClose: () => void;
};

export const StopwordCard = ({
    matchedWord,
    title,
    message,
    badgeText,
    onClose,
}: StopwordCardProps) => {
    return (
        <div className="mt-2 mb-4 flex flex-col gap-4 rounded-2xl border border-gray-400 bg-gray-100 p-4">
            <div className="flex flex-row items-center justify-between">
                <Badge type="neutral" className="py-2">
                    {badgeText || Utils.uppercaseFirst(matchedWord)}
                </Badge>
                <CloseIcon
                    className="hover:text-primary cursor-pointer"
                    onClick={onClose}
                />
            </div>
            <h5>{title}</h5>
            <div
                dangerouslySetInnerHTML={{
                    __html: Utils.decodeHtml(message),
                }}
            ></div>
        </div>
    );
};
